import styled from 'styled-components';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { Background, Border, Text } from 'styles/themeColors';
import { Space } from 'styles/themeSpaces';
import { BorderRadius } from 'styles/themeBorderRadius';
import { FontWeight } from 'lib/styles';

// Shared table styling for the "Search results" and "Items in this order" sections, so both
// tables read as one visual system.
export const TableWrapper = styled.div`
  border: 1px solid ${Border.light};
  border-radius: ${BorderRadius.m};
  margin-top: ${Space.sp2x};
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const HeaderCell = styled.th<any>`
  background-color: ${Background.shaded};
  color: ${Text.secondary};
  font-size: 14px;
  font-weight: ${FontWeight.bold};
  line-height: 18px;
  padding: ${Space.spBasePlus} ${Space.spBase};
  text-align: ${({ align }) => align || 'left'};
  width: ${({ width }) => width};
`;

export const ActionCellContent = styled(FlexboxContainer).attrs({ justifyContent: 'center' })`
  width: 100%;
`;

export const BodyCell = styled.td<any>`
  border-bottom: 1px solid ${Border.light};
  padding: ${Space.spBasePlus} ${Space.spBase};
  text-align: ${({ align }) => align || 'left'};
  vertical-align: middle;
  font-size: 14px;
  line-height: 18px;
  color: ${Text.primary};
`;

export const ProductImage = styled.img`
  height: 40px;
  width: 40px;
  object-fit: contain;
  flex-shrink: 0;
`;

export const ProductName = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${Text.primary};
`;

export const ProductDescription = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${Text.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SkuText = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${Text.primary};
  word-break: break-word;
`;

export const SectionCard = styled(FlexboxContainer).attrs({ flexDirection: 'column' }) <any>`
  border: 1px solid ${Border.light};
  border-radius: ${BorderRadius.m};
  background-color: ${Background.white};
  box-sizing: border-box;
  padding: ${Space.sp2xPlus};
  margin: 0 ${Space.sp2x} ${Space.sp2x};
`;

export const SectionTitle = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${FontWeight.bold};
  color: ${Text.primary};
`;

export const SectionSubtitle = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${Text.secondary};
  margin-top: ${Space.spHalf};
`;

export const HelperText = styled.span`
  font-size: 12px;
  line-height: 18px;
  color: ${Text.secondary};
`;

export const TotalLabel = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${FontWeight.bold};
  color: ${Text.primary};
`;

export const TotalValue = styled.span`
  font-size: 20px;
  line-height: 28px;
  font-weight: ${FontWeight.bold};
  color: ${Text.primary};
  margin-left: ${Space.sp3x};
`;
